import { combineReducers } from 'redux';

import { reducer as courses } from '@sayyesschool/frontend/features/courses';
import { reducer as dictionary } from '@sayyesschool/frontend/features/dictionary';
import { reducer as exercises } from '@sayyesschool/frontend/features/exercises';
import { reducer as materials } from '@sayyesschool/frontend/features/materials';
import { reducer as vocabularies } from '@sayyesschool/frontend/features/vocabularies';
import { reducer as notification } from '@sayyesschool/frontend/store/features/notification';

export default combineReducers({
    courses,
    materials,
    exercises,
    notification,
    dictionary,
    vocabularies
});